import React, { forwardRef } from 'react';
import styles from './form.module.scss';

type TextInputProps = {
    value?: string;
    placeholder?: string;
    suffix?: string;
    disabled?: boolean;
    maxLength?: number;
    type?: 'text' | 'number';
    onChange?: (value: string) => void;
    onKeyPress?: (e: React.KeyboardEvent) => void;
};

export const TextInput = forwardRef<HTMLInputElement, TextInputProps>(
    (
        {
            value = '',
            placeholder,
            suffix,
            disabled = false,
            maxLength,
            type = 'text',
            onChange,
            onKeyPress,
        },
        ref,
    ) => {
        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            let val = e.target.value;
            if (type === 'number') {
                val = val.replace(/[^0-9]/g, '');
            }
            if (maxLength && val.length > maxLength) {
                val = val.slice(0, maxLength);
            }
            onChange?.(val);
        };

        return (
            <div className={styles.textInputWrapper}>
                <input
                    ref={ref}
                    className={styles.textInput}
                    value={value}
                    placeholder={placeholder}
                    disabled={disabled}
                    inputMode={type === 'number' ? 'numeric' : 'text'}
                    onChange={handleChange}
                    onKeyPress={onKeyPress}
                    autoComplete="off"
                />
                {suffix && <span className={styles.textInputSuffix}>{suffix}</span>}
            </div>
        );
    },
);

TextInput.displayName = 'TextInput';
